import React, { useEffect, useState } from "react";
import $ from "jquery";
import "./style.css";
import "select2/dist/css/select2.min.css"; // Import Select2 CSS
import "select2"; // Import Select2 JS
import CENModal from "../CENModal/CENModal";
import filterIcon from "../../assets/filter-icons.svg";

function FiltersBoxUi({
  selectData,
  filtersId,
  applyFilter,
  removeFilter,
  decodedToken,
  handleRadioChange,
  isFilter,
  setIsFilter,
  setFiltersId,
  setShowModal,
  showModal,
  setCenSearch,
  cenSearch,
  selectedCEN,
  cenData
}) {
  // const [pending, setPending] = useState(true)
  const handleRemoveFilter = (key) => {
    setFiltersId({ ...filtersId, [key]: "" }); // Clear the filter value
    applyFilter();
    setIsFilter(true);
    // removeFilter(updatedFilters); // Call the remove filter method
  };
  
  const getLabelFromId = (key, id) => {
  
    if (key === "auditorId" && id) {
      const auditor = selectData?.userData?.find((val) => val?.id == id);
      return auditor ? `${auditor?.firstname} ${auditor?.lastname}` : id;
    }
    if (key === "rrbId" && id) {
      const rrbData = selectData?.rrb?.find((val) => val?.id == id);
      return rrbData ? `${rrbData?.name}` : id;
    }
    if (key === "stateId" && id) {
      const stateData = selectData?.states?.find((val) => val?.id == id);
      return stateData ? `${stateData?.name}` : id;
    }
    if (key === "cityId" && id) {
      const stateData = selectData?.city?.find((val) => val?.id == id);
      return stateData ? `${stateData?.name}` : id;
    }
    if (key === "status" && id) {
      const statusMap = {
        submitted: "Submitted",
        "not-submitted": "Not Submitted",
        pending:"Pending"
      };
      return statusMap[id] || id;
    }
     
    return id; // Fallback for unhandled cases
  };

  const renderAppliedFilters = () => {
    const appliedFilters = Object.entries(filtersId).filter(
      ([key, value]) => value !== "" && value !== undefined && key !== "cen_id"
    );

    return appliedFilters?.map(([key, value]) => (
      // <span key={key} className="badge badge-secondary m-1">
      //   {key}: {value}
      //   <button
      //     type="button"
      //     className="btn btn-sm btn-light ml-2"

      //   >
      //     ✕
      //   </button>
      // </span>
      <div>
        <button
          type="button"
          className="btn btn-secondary rounded-5 px-2 ml-2 h-30px f-12px"
          onClick={() => handleRemoveFilter(key)}
        >
          {getLabelFromId(key, value)} <i className="fa fa-times f-12px"></i>
        </button>
      </div>
    ));
  };


  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className="card-body">
            <div className="modal-filter-card">
              {/* <h5 className="filter-heading">Filters</h5> */}
              {selectedCEN ?
              <div className="d-flex align-items-center mb-2 cursor-pointer"  onClick={() => setShowModal(true)}>
                <h5
                  className="mb-0 filter-heading cursor-pointer"
                >
                  {selectedCEN?.name}
                </h5>
                <img src={filterIcon} alt="icons" className="filter-icon"/>
              </div>:null}
              <div>
                <div className="card-body">
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-4">
                        <div className="form-group mb-0">
                          <label className=" filters_label">Center Status</label>
                          <div>
                            <select
                              id="status"
                              name="status"
                              className="form-control w-100 p-2 select_css select2bs4"
                              style={{ width: "100%" }}
                              value={filtersId?.status}
                              // onChange={handleRadioChange}
                            >
                              <option value="">Select Status</option>
                              <option value="submitted">Completed</option>
                              <option value="not-submitted">
                              In Progress
                              </option>
                              <option value="pending" 
                              //  onClick={() => setPending(false)}
                               >
                              Pending
                              </option>

                            </select>
                          </div>
                          {/* <div className="d-flex align-items-center py-2">
                            <div className="form-check mr-3">
                              <input
                                type="radio"
                                id="submitted"
                                name="status"
                                value="submitted"
                                className="form-check-input"
                                checked={filtersId?.status === "submitted"}
                                onChange={handleRadioChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="submitted"
                              >
                                Submitted
                              </label>
                            </div>

                            <div className="form-check mr-3">
                              <input
                                type="radio"
                                id="not-submitted"
                                name="status"
                                value="not-submitted"
                                className="form-check-input"
                                checked={filtersId?.status === "not-submitted"}
                                onChange={handleRadioChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="not-submitted"
                              >
                                Not Submitted
                              </label>
                            </div>
                          </div> */}
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group mb-0">
                          <label className=" filters_label">Audit Status</label>
                          <div>
                            <select
                              id="audit_status"
                              name="audit_status"
                              className="form-control w-100 p-2 select_css select2bs4"
                              style={{ width: "100%" }}
                              value={filtersId?.audit_status}
                              // onChange={handleRadioChange}
                            >
                              <option value="">Select Status</option>
                              <option value="pending">Pending Approval</option>
                              <option value="approved">
                              Approved
                              </option>
                              <option value="partially_approved" 
                              //  onClick={() => setPending(false)}
                               >
                              Conditional Approval
                              </option>
                              <option value="rejected" 
                              //  onClick={() => setPending(false)}
                               >
                              Rejected
                              </option>

                            </select>
                          </div>
                          {/* <div className="d-flex align-items-center py-2">
                            <div className="form-check mr-3">
                              <input
                                type="radio"
                                id="submitted"
                                name="status"
                                value="submitted"
                                className="form-check-input"
                                checked={filtersId?.status === "submitted"}
                                onChange={handleRadioChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="submitted"
                              >
                                Submitted
                              </label>
                            </div>

                            <div className="form-check mr-3">
                              <input
                                type="radio"
                                id="not-submitted"
                                name="status"
                                value="not-submitted"
                                className="form-check-input"
                                checked={filtersId?.status === "not-submitted"}
                                onChange={handleRadioChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="not-submitted"
                              >
                                Not Submitted
                              </label>
                            </div>
                          </div> */}
                        </div>
                      </div>
                 
                      <div className="col-4">
                        <div>
                          <div class="form-group">
                            <label htmlFor="select" className=" filters_label">
                              {" "}
                              Auditor
                            </label>
                            <div>
                              <select
                                id="auditor_id"
                                name="auditor_id"
                                className="form-control w-100 p-2 select_css select2bs4"
                                style={{ width: "100%" }}
                                value={filtersId?.auditorId}
                              >
                                <option value="">Select Auditor</option>
                                {selectData?.userData?.map((val) => {
                                  const id = val?.id;
                                  // const name = val?.firstname val?.lastname;
                                  return (
                                    <option key={val.id} value={id}>
                                      {val.firstname} {val.lastname}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="col-4">
                        <div>
                          <div class="form-group">
                            <label
                              htmlFor="select"
                              className=" filters_label"
                            >
                              {" "}
                              Select Auditor:
                            </label>
                            <div>
                              <select
                                class="w-100 p-2 select_css form-control select2bs4 "
                                style={{ width: "100%" }}
                              >
                                <option selected="selected">Alabama</option>
                                <option>Alaska</option>
                                <option>California</option>
                                <option>Delaware</option>
                                <option>Tennessee</option>
                                <option>Texas</option>
                                <option>Washington</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div> */}
                  {
                    filtersId?.status !== 'pending' && (    <div className="col-4">
                      <div className="form-group mb-0">
                        <label className=" filters_label">
                          Date range
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control float-left"
                            id="filter_date_reservation"
                            name="dateRange" // Update the name to match Formik's state
                          />
                          <div className="input-group-prepend ">
                            <span className="input-group-text calender-icon-custom-border-radius">
                              <i className="far fa-calendar-alt" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>)
                  }

                      {(decodedToken?.role == 3 || decodedToken?.role == 4) && (
                        <div className="col-4">
                          <div>
                            <div class="form-group">
                              <label
                                htmlFor="select"
                                className=" filters_label"
                              >
                                {" "}
                                RRB
                              </label>
                              <div>
                                <select
                                  id="rrb_id"
                                  name="rrb_id"
                                  className="form-control w-100 p-2 select_css select2bs4"
                                  style={{ width: "100%" }}
                                  value={filtersId?.rrbId}
                                >
                                  <option value="">Select RRB</option>
                                  {selectData?.rrb?.map((val) => {
                                    const id = val?.id;
                                    return (
                                      <option value={id}>{val.name}</option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-4">
                        <div>
                          <div class="form-group">
                            <label htmlFor="select" className=" filters_label">
                              State
                            </label>
                            <div>
                              <select
                                id="state_id"
                                name="state_id"
                                value={filtersId?.stateId}
                                className="form-control w-100 p-2 select_css select2bs4"
                                style={{ width: "100%" }}
                              >
                                <option value="">Select State</option>
                                {selectData?.states?.map((val) => {
                                  const id = val?.id;
                                  return <option value={id}>{val.name}</option>;
                                })}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-4">
                        <div>
                          <div class="form-group">
                            <label htmlFor="select" className=" filters_label">
                              City
                            </label>
                            <div>
                              <select
                                id="city_id"
                                name="city_id"
                                value={filtersId?.cityId}
                                className="form-control w-100 p-2 select_css select2bs4"
                                style={{ width: "100%" }}
                              >
                                <option value="">Select City</option>
                                {selectData?.city?.map((val) => {
                                  const id = val?.id;
                                  return <option value={id}>{val.name}</option>;
                                })}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-4">
                        <div
                          className="d-flex "
                          style={{
                            marginTop: `${"26px"}`,
                          }}
                        >
                          <button
                            className="modal_filters_clear_btn "
                            onClick={() => {
                              removeFilter();
                              setIsFilter(false);
                            }}
                          >
                            Clear
                          </button>
                          <button
                            className="modal_filters_apply_btn ml-3"
                            onClick={() => {
                              applyFilter();
                              setIsFilter(true);
                            }}
                          >
                            Apply
                          </button>
                        </div>
                        {/* {isFilter &&
                      <div >
                       <p className="text-danger mb-0">
                        Filter Applied
                       </p>
                      </div>} */}
                      </div>
                    </div>
                    {/* <div className="d-flex align-items-center mt-3">
                      <h6>Applied Filters:</h6>
                      {renderAppliedFilters()}
                    </div> */}
                    {/* <div className="row mt-3">
                      <div className="col-1">
                        <button
                          className="modal_filters_clear_btn"
                          onClick={()=>{removeFilter();setIsFilter(false)}}
                        >
                          Clear
                        </button>
                      </div>
                      <div className="col-1">
                        <button
                          className="modal_filters_apply_btn"
                          onClick={()=>{applyFilter();setIsFilter(true)}}
                        >
                          Apply
                        </button>
                      </div>
                      {isFilter &&
                      <div className="col-2 ">
                       <p className="text-danger mb-0">
                        Filter Applied
                       </p>
                      </div>}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal ? (
        <CENModal
          data={cenData}
          setShowModal={setShowModal}
          setCenSearch={setCenSearch}
          cenSearch={cenSearch}
          setFiltersId={setFiltersId}
          filtersId={filtersId}
        />
      ) : null}
    </div>
  );
}

export default FiltersBoxUi;
